<template>
  <div class="a-sheet collapse" id="pz-scantron">
    <div class="modal-header align-items-center bg-light">
      <div class="flex-grow-1 d-flex align-items-center">
        <h5 class="modal-title">答题卡 {{ Position }}/{{ QuestionList.length }}</h5>
        <div class="text-success mx-2 d-flex" v-if="!isTakingExam">
          <i class="pz-icon icon-check-circle mr-1"></i>
          {{ CorrecttingStatus.right }}
        </div>
        <div class="text-danger mx-2 d-flex" v-if="!isTakingExam">
          <i class="pz-icon icon-cancel mr-1"></i>
          {{ CorrecttingStatus.wrong }}
        </div>
      </div>
      <button
        class="btn btn-link text-dark"
        type="button"
        data-toggle="collapse"
        data-target="#pz-scantron"
        aria-expanded="false"
        aria-controls="a-sheet"
      >
        <i class="pz-icon icon-close"></i>
      </button>
    </div>
    <div class="modal-body p-5 overflow-auto">
      <template v-for="(book, bookIdx) in Scantron">
        <h6 :key="`scantron-question-h6-${bookIdx}`">{{ book.bookName }}</h6>
        <ul
          :key="`scantron-question-ul-${bookIdx}`"
          class="pagination pagination-lg pagination-sheet"
        >
          <li
            class="page-item"
            :class="{
              right: q.questionStatus === 1 && !isTakingExam,
              error: q.questionStatus === -1 && !isTakingExam,
              answered: q.questionStatus !== 0 && isTakingExam,
              active: q.questionId === Question.questionId,
            }"
            v-for="(q, qIdx) in book.questions"
            :key="`scantron-question-li-${qIdx}`"
          >
            <a
              class="page-link"
              href="javascript:undefined"
              data-toggle="collapse"
              data-target=".a-sheet"
              aria-expanded="false"
              aria-controls="a-sheet"
              @click.prevent="onSelect(q.questionId)"
              >{{ q.idx + 1 }}
              <span
                v-if="q.haveNote"
                class="position-absolute bg-grey-100 rounded-circle d-flex justify-content-center align-items-center"
                style="bottom: 0px; right: -5px; width: 24px; height: 24px"
              >
                <i class="pz-icon icon-create _xs text-info"></i>
              </span>
            </a>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
import { groupBy } from 'lodash';
export default {
  name: 'Scantron',

  components: {},

  props: {
    QuestionList: {
      type: Array,
      default: () => [],
    },

    isTakingExam: {
      type: Boolean,
      default: () => false,
    },

    Question: Object,

    onSelect: {
      type: Function,
      default: () => {},
    },

    Position: {
      type: Number,
      default: () => 0,
    },
  },

  computed: {
    // Position: function() {
    //   if (this.QuestionList.length) {
    //     return (
    //       findIndex(this.QuestionList, {
    //         questionId: this.Question.questionId,
    //       }) + 1
    //     );
    //   }
    //   return 0;
    // },

    CorrecttingStatus: function () {
      if (this.QuestionList.length) {
        const obj = groupBy(this.QuestionList, 'questionStatus');
        return {
          wrong: obj['-1'] ? obj['-1'].length : 0,
          right: obj['1'] ? obj['1'].length : 0,
        };
      }
      return {
        wrong: 0,
        right: 0,
      };
    },

    Scantron: function () {
      if (this.QuestionList.length) {
        const obj = groupBy(this.QuestionList, 'bookName');
        let arr = [];
        for (let key in obj) {
          arr.push({
            bookName: key,
            questions: obj[key],
          });
        }
        let idx = 0;
        for (let i = 0, l = arr.length; i < l; i++) {
          const questions = arr[i].questions;
          for (let ii = 0, ll = questions.length; ii < ll; ii++) {
            questions[ii]['idx'] = idx;
            idx++;
          }
        }
        return arr;
      }
      return [];
    },
  },
};
</script>
